import { Component } from '@angular/core';

@Component({
  selector: 'app-quickstart',
  standalone: false,
  templateUrl: './quickstart.component.html',
  styleUrl: './quickstart.component.css'
})
export class QuickstartComponent {

}
